<script setup lang="ts">
import {PropType} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import ListViewUtils from "@/utils/common/ListViewUtils.ts";

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});
let fieldValue: number = props.params?.value ? props.params?.value : 0;

function onInputChange(event) {
  let newValue = parseInt(event.target.value);
  let params = props.params!;
  params.data[ListViewUtils.REPEAT_COUNT_COLUMN_ID] = newValue;
  let rowNode = params.api.getRowNode(params.data.namaRowIndex);
  rowNode?.setSelected(!!newValue);
}
</script>

<template>
  <input
    type="number" class="tw-py-0 tw-px-1 tw-w-full focus:tw-ring-0" min="0"
    :value="fieldValue"
    @change="onInputChange"
    @click.prevent.stop
    style="border: none; background: transparent;"
  />
</template>

<style scoped>

</style>
